<!--
 * @Description: 预采购任务导入失败列表
 * @Date: 2022-03-08 10:16:05
-->
<template>
  <el-dialog
    title="导入失败"
    :visible="true"
    width="65%"
    top="2vh"
    :before-close="() => $emit('remove')"
  >
    <table-render
      ref="tableRender"
      :config="config"
      @handCellClick="handleClick"
      :getListFinished="getListFinished"
      height="45vh"
      :hidePagination="true"
      :prop-data="{
        query: {
          redisKey: fileForm.redisKey,
          projectId: fileForm.projectId
        }
      }"
    >
      <template slot="top-alert" slot-scope="scope">
        <div class="error-alert">
          <p>
            信息校验结果:
            {{ sizeSuccess }}
          </p>
          <p>导入结果: 整批导入失败</p>
          <p>错误内容:</p>
        </div>
      </template>
      <template slot="batchAction" slot-scope="scope">
        <el-button @click="downLoad" type="primary">
          下载原上传EXCEL
        </el-button>
      </template>
    </table-render>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="againSubmit">重新提交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import tableRender from '@/components/tableRender';
import { importProjectPeople } from '@/api/ajax';
import { mapState } from 'vuex';
//去重
const unique = arr => {
  const res = new Map();
  return arr.filter(item => !res.has(item.xh) && res.set(item.xh, 1));
};

export default {
  name: 'importFailTable',
  props: {
    fileForm: {
      type: Object,
      default: () => ({})
    }
  },
  components: { tableRender },
  data() {
    return {
      isCellShow: '', // 展示要修改的单元格
      errorXhs: [], //删除的项
      taskPlanExcelVoListStr: [], //修改的项
      tableRespons: {
        total: '',
        errorListSize: ''
      }
    };
  },
  computed: {
    ...mapState({
      homeProject: state => state.homeProject
    }),
    config() {
      let arr = [
        {
          name: '预采购任务导入失败列表',
          childMenu: [
            {
              list: importProjectPeople.importExcelErrorList,
              requestNow: true,
              fields: [
                {
                  label: '表格位置',
                  prop: 'xh',
                  formatter: row => `第${row.xh}行`
                },
                {
                  label: '个体名称',
                  prop: 'enterpriseName',
                  hide: +this.homeProject.userEnterpriseType !== 2, //普通个体展示
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'enterpriseName' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.enterpriseName = e;
                        }}
                        v-model={row.enterpriseName}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">
                        {row.enterpriseName || '-'}
                      </el-button>
                    );
                  }
                },
                {
                  label: '姓名',
                  prop: 'userName',
                  hide: +this.homeProject.userEnterpriseType !== 0, // 非个体展示
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'userName' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.userName = e;
                        }}
                        v-model={row.userName}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">{row.userName || '-'}</el-button>
                    );
                  }
                },
                {
                  label: '经营者',
                  prop: 'userName',
                  hide: +this.homeProject.userEnterpriseType !== 2, // 普通个体展示
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'userName' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.userName = e;
                        }}
                        v-model={row.userName}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">{row.userName || '-'}</el-button>
                    );
                  }
                },
                {
                  label: '手机号',
                  prop: 'phone',
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'phone' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.phone = e;
                        }}
                        v-model={row.phone}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">{row.phone || '-'}</el-button>
                    );
                  }
                },
                {
                  label: '预采购任务量',
                  prop: 'taskNum',
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'taskNum' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.taskNum = e;
                        }}
                        v-model={row.taskNum}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">{row.taskNum || '-'}</el-button>
                    );
                  }
                },
                {
                  label: '人员标签',
                  prop: 'userTag',
                  render: (h, ctx, row) => {
                    return this.isCellShow === 'userTag' + row.xh ? (
                      <el-input
                        ref="editInput"
                        onInput={e => {
                          row.userTag = e;
                        }}
                        v-model={row.userTag}
                        onBlur={() => {
                          this.isCellShow = '';
                          this.taskPlanExcelVoListStr.push(row);
                        }}
                      ></el-input>
                    ) : (
                      <el-button type="text">{row.userTag || '-'}</el-button>
                    );
                  }
                },
                {
                  label: '错误提示',
                  width: '350px',
                  render: (h, ctx, row) => {
                    return row.whetherTheMistakeStr.map((item, index) => {
                      return <p>{`${index + 1}.${item}`}</p>;
                    });
                  }
                },
                {
                  label: '操作',
                  render: (h, ctx, row, col, k, index) => {
                    return (
                      <el-button
                        onClick={() => {
                          this.$confirm('此操作将删除该项, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(() => {
                            this.errorXhs.push(row.xh);
                            this.$refs.tableRender.tableData.splice(index, 1);
                            this.$message({
                              type: 'success',
                              message: '删除成功!'
                            });
                          });
                        }}
                        type="text"
                      >
                        删除
                      </el-button>
                    );
                  }
                }
              ]
            }
          ]
        }
      ];
      arr[0].childMenu[0].fields = arr[0].childMenu[0].fields.filter(
        item => !item.hide
      );
      return arr;
    },
    sizeSuccess() {
      return `导入${this.tableRespons.total || '-'}条，失败${this.tableRespons
        .errorListSize || '-'}条`;
    }
  },
  methods: {
    cancel() {
      this.$emit('removeRedisKey');
      this.$emit('remove');
    },
    downLoad() {
      this.$downloadFile(
        `${importProjectPeople.importExcelErrorDownLod}?projectId=${this.fileForm.projectId}&redisKey=${this.fileForm.redisKey}`,
        true
      );
    },
    async againSubmit() {
      await this.$confirm('是否确认重新提交?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        const {
          data: {
            code,
            message,
            data: { redisKey }
          }
        } = await importProjectPeople.importExcelNew({
          ...this.fileForm,
          errorXhs: this.errorXhs.join(','),
          taskPlanExcelVoListStr: JSON.stringify(
            unique(this.taskPlanExcelVoListStr)
          ),
          secondaryConfirmation: 1
        });
        if (+code === 3) {
          this.$notify({
            message,
            type: 'error'
          });
          // 重新提交后还有错误数据
          this.fileForm = { ...this.fileForm, redisKey };
          this.$refs.tableRender.searchQuery = {
            projectId: this.fileForm.projectId,
            redisKey: this.fileForm.redisKey
          };
          this.errorXhs = []; //删除的项
          this.taskPlanExcelVoListStr = []; //修改的项
          this.$refs.tableRender.initWatchRouteChange();
        } else if (![2, 3].includes(+code)) {
          this.$emit('ok');
          this.$emit('remove');
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
      } catch (e) {
        console.error(e);
      }
      loading.close();
    },
    handleClick({ row, column }) {
      // 单元格'prop+xh'组合方式区分
      this.isCellShow = column.property + row.xh;
      this.$nextTick(() => {
        this.$refs.tableRender.$refs['editInput'].focus();
      });
    },
    getListFinished(res) {
      this.tableRespons = res;
    }
  }
};
</script>

<style scoped lang="scss">
>>> .el-dialog__footer {
  text-align: center;
}
.error-alert {
  p {
    margin-bottom: 10px;
    color: red;
  }
}
</style>
